/**
 * image
 */

import Component from '../../js/lib/component';
import 'lightgallery';

const classList = {
  root: '.js-image',
  image: '.js-image-src'
};

export default class Image extends Component {
  init() {
    this.$.root.lightGallery({
      selectWithin: this.$.root.data('parent') || '',
      selector: classList.image,
      download: false,
      counter: false,
      startClass: 'lg-fade',
      getCaptionFromTitleOrAlt: false
    });
  }
}

Component.mount(Image, {
  name: 'Image',
  classList,
  state: {}
});
